import {
  Activity, AlertOctagon, Crosshair, HelpCircle, BarChart2, Box, CheckSquare, Code, FileText, Globe, Grid, Home, Inbox, Layers,
  LifeBuoy, List, TrendingUp, XCircle, MessageSquare, PieChart, Search, Send, Server, Settings, Shield, Smartphone, Trash2, Users, Zap,
} from 'react-feather';

const P = process.env.PUBLIC_URL || '';

/** Navigation for operations staff (ADMIN / SUPPER_ADMIN). */
export const adminNav = [
  {
    group: 'Monitor',
    items: [
      { label: 'Overview', to: `${P}/dashboard/home`, icon: Home },
      { label: 'Issues', to: `${P}/dashboard/ops/issues`, icon: AlertOctagon },
      { label: 'Network report', to: `${P}/dashboard/ops/network`, icon: BarChart2 },
      { label: 'Unmatched traffic', to: `${P}/dashboard/ops/unmatched`, icon: Inbox },
      { label: 'Partner subscriptions', to: `${P}/dashboard/ops/subscriptions`, icon: TrendingUp },
      { label: 'Failed charges', to: `${P}/dashboard/ops/billing-failed`, icon: XCircle },
      // superadmin: shown only to SUPPER_ADMIN (Shared/BillingExceptions/helpers filterSuperadminNav)
      { label: 'Billing exceptions', to: `${P}/dashboard/ops/billing-exceptions`, icon: AlertOctagon, superadmin: true },
      { label: 'Partner webhooks', to: `${P}/dashboard/ops/webhooks`, icon: Send },
      { label: 'USSD menus', to: `${P}/dashboard/ops/ussd`, icon: Smartphone },
      { label: 'Network IPs', to: `${P}/dashboard/ops/network-ips`, icon: Shield },
    ],
  },
  {
    group: 'Partners',
    items: [
      { label: 'Account verification', to: `${P}/dashboard/accounts`, icon: CheckSquare },
      { label: 'Service onboarding', to: `${P}/dashboard/services`, icon: Layers },
      { label: 'Aggregator documents', to: `${P}/dashboard/aggregator-documents`, icon: FileText },
      { label: 'GCMS integrations', to: `${P}/dashboard/gcms`, icon: Grid },
      { label: 'Partners', to: `${P}/dashboard/usermanager/user-list`, icon: Users },
      { label: 'Partner shortcodes', to: `${P}/dashboard/partner-shortcode`, icon: Grid },
    ],
  },
  {
    group: 'Reports',
    items: [
      { label: 'Summary', to: `${P}/dashboard/report/summarize-report`, icon: PieChart },
      { label: 'By product', to: `${P}/dashboard/report/report-by-product`, icon: BarChart2 },
      { label: 'Subscribers', to: `${P}/dashboard/report/subscribers-list`, icon: List },
      { label: 'Subscriber base', to: `${P}/dashboard/report/active-count`, icon: Activity },
      { label: 'Active list', to: `${P}/dashboard/report/active-list`, icon: List },
      { label: 'Events', to: `${P}/dashboard/report/events`, icon: Zap, exact: true },
      { label: 'Exports', to: `${P}/dashboard/report/events/exports`, icon: FileText },
      { label: 'Sync failures', to: `${P}/dashboard/report/partner-sync-failures`, icon: AlertOctagon },
      { label: 'Daily reports', to: `${P}/dashboard/email-report`, icon: MessageSquare },
    ],
  },
  {
    group: 'Products',
    items: [
      { label: 'Products', to: `${P}/dashboard/product/product-list`, icon: Box },
      { label: 'Create product', to: `${P}/dashboard/product/create-product`, icon: Box },
      { label: 'Shortcodes', to: `${P}/dashboard/shortcode/shortcode-list`, icon: Grid },
      { label: 'Subscribe a shortcode', to: `${P}/dashboard/shortcode/subscribe`, icon: Send },
      { label: 'Subscription status', to: `${P}/dashboard/shortcode/subscription-status`, icon: Search },
      { label: 'Help message', to: `${P}/dashboard/configuration/help-message`, icon: LifeBuoy },
      { label: 'Invalid keyword reply', to: `${P}/dashboard/configuration/invalid-keyword`, icon: MessageSquare },
    ],
  },
  {
    group: 'Tools',
    items: [
      // action: opens the Eudor VAS Log Tracer (logs.eudorng.com) in a new tab, signed in (Shared/LogTracer)
      { label: 'Log tracer', action: 'log-tracer', icon: Crosshair, external: true },
      { label: 'Log file search', to: `${P}/dashboard/log-tracer`, icon: Search },
      { label: 'API checker', to: `${P}/dashboard/api-checker`, icon: Server },
      { label: 'Partner checker', to: `${P}/dashboard/partner-checker`, icon: Globe },
      { label: 'Data retention', to: `${P}/dashboard/retention`, icon: Trash2 },
      { label: 'Help', to: `${P}/dashboard/help`, icon: HelpCircle },
    ],
  },
  {
    group: 'Settings',
    items: [{ label: 'GCMS rate card', to: `${P}/dashboard/settings/gcms-rate-card`, icon: Settings }],
  },
];

/** Navigation for an approved partner. */
export const partnerNav = [
  {
    group: 'Overview',
    items: [
      { label: 'Dashboard', to: `${P}/partner/home`, icon: Home },
      { label: 'Daily summary', to: `${P}/partner/daily-summary`, icon: BarChart2 },
      // Shown only when an admin has switched analytics on for the partner (see Shell/features.js).
      { label: 'Analytics', to: `${P}/partner/analytics`, icon: TrendingUp, feature: 'analytics_enabled' },
    ],
  },
  {
    group: 'Services',
    items: [
      { label: 'Service onboarding', to: `${P}/partner/services`, icon: Layers },
      { label: 'Products', to: `${P}/partner/product/product-list`, icon: Box },
      { label: 'Create product', to: `${P}/partner/product/create-product`, icon: Box },
      { label: 'Send message', to: `${P}/partner/messages/send-message`, icon: Send },
    ],
  },
  {
    group: 'Reports',
    items: [
      { label: 'Summary', to: `${P}/partner/report/summarize-report`, icon: PieChart },
      { label: 'By product', to: `${P}/partner/report/report-by-product`, icon: BarChart2 },
      { label: 'Subscribers', to: `${P}/partner/report/subscribers-list`, icon: List },
      { label: 'Events', to: `${P}/partner/report/events`, icon: Zap, exact: true },
      { label: 'Exports', to: `${P}/partner/report/events/exports`, icon: FileText },
      { label: 'Sync failures', to: `${P}/partner/report/sync-failures`, icon: AlertOctagon },
      { label: 'GCMS integrations', to: `${P}/partner/report/gcms`, icon: Grid },
    ],
  },
  {
    group: 'Integration',
    items: [
      { label: 'GCMS services', to: `${P}/partner/gcms`, icon: Grid },
      { label: 'Sandbox', to: `${P}/partner/sandbox`, icon: Code },
      { label: 'USSD menu request', to: `${P}/partner/notification/ussd-menu-request`, icon: Smartphone },
      { label: 'SMS notification', to: `${P}/partner/notification/sms`, icon: MessageSquare },
      { label: 'Subscription notification', to: `${P}/partner/notification/sync-subscription`, icon: Send },
      { label: 'Renewal notification', to: `${P}/partner/notification/sync-renewal`, icon: Send },
      { label: 'Unsubscription notification', to: `${P}/partner/notification/sync-unsubscription`, icon: Send },
      { label: 'Daily report', to: `${P}/partner/notification/daily-report`, icon: Settings },
    ],
  },
  {
    group: 'Account',
    items: [
      { label: 'Company verification', to: `${P}/partner/verification`, icon: CheckSquare },
      { label: 'Help', to: `${P}/partner/help`, icon: HelpCircle },
    ],
  },
];

/** A partner whose company verification is not complete yet. */
export const pendingPartnerNav = [
  {
    group: 'Get started',
    items: [
      { label: 'Company verification', to: `${P}/partner/verification`, icon: CheckSquare },
      { label: 'Sandbox', to: `${P}/partner/sandbox`, icon: Code },
      { label: 'Help', to: `${P}/partner/help`, icon: HelpCircle },
    ],
  },
];
